const openCloseEditGroup = (state, action) => ({
  ...state,
  editGroupDialogOpenFor: action.payload.editGroupDialogOpenFor,
});

export default openCloseEditGroup;
